/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_Showcase_Concierge_TitleInputs */

const en_meta_showcase_concierge_title = /** @type {(inputs: Meta_Showcase_Concierge_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Hotel Concierge & Booking Assistant Demo | Lindevo`)
};

const lv_meta_showcase_concierge_title = /** @type {(inputs: Meta_Showcase_Concierge_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI konsjeržs viesnīcas mājaslapā — demo | Lindevo`)
};

/**
* | output |
* | --- |
* | "AI Hotel Concierge & Booking Assistant Demo \| Lindevo" |
*
* @param {Meta_Showcase_Concierge_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const meta_showcase_concierge_title = /** @type {((inputs?: Meta_Showcase_Concierge_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Showcase_Concierge_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_meta_showcase_concierge_title(inputs)
	return en_meta_showcase_concierge_title(inputs)
});